module.exports = __webpack_public_path__ + "static/media/pen-and-paper.4c5bf9fc.jpg";